import { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useUsers } from "./useUsers";
import Logo from "../../sharable/Logo";
import Notification from "../../sharable/Notification";
import UserPaymentsDashboard from "../UserPaymentsDashboard/UserPaymentsDashboard";
import { ModalOverlay, ModalContent } from "./UsersDashboard.styles";
import {
  ClearButton,
  Container,
  Header,
  PageButton,
  Pagination,
  SearchButton,
  SearchInput,
  Table,
  TableWrapper,
  Title,
} from "./UsersDashboard.styles";

export default function UsersDashboard() {
  const [selectedUserPayments, setSelectedUserPayments] = useState(null);
  const { user, token } = useOutletContext();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const { users, loading, totalPages, error } = useUsers(
    token,
    page,
    size,
    search,
  );

  const getWhatsappHref = (whatsapp) => {
    const digitsOnly = String(whatsapp || "").replace(/\D/g, "");
    if (!digitsOnly) return null;
    return `https://wa.me/${digitsOnly}`;
  };

  console.log("USERS:", users);

  if (!user || user.authority !== "ADMIN") {
    return (
      <Container>
        <Header>
          <Logo showGoBackButton={true} path="/encartes" />
        </Header>
        <Title>Administração</Title>
        <div>Você não tem permissão para acessar este painel.</div>
      </Container>
    );
  }

  return (
    <Container>
      <Header>
        <Logo showGoBackButton={true} path="/encartes" />
      </Header>
      <Title>Painel de Usuários</Title>
      <div style={{ marginBottom: "1.5rem" }}>
        <Link
          to="/user-payments-dashboard"
          style={{
            color: "#d97706",
            fontWeight: 600,
            borderBottom: "1px solid #d97706",
            textDecoration: "none",
            marginRight: "1.5rem",
          }}
        >
          Ver todos os pagamentos
        </Link>
      </div>
      {error && <Notification message={error} type="error" />}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1.5rem",
        }}
      >
        <SearchInput
          type="text"
          placeholder="Buscar usuário por nome, email..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <SearchButton
          onClick={() => {
            setSearch(searchInput);
            setPage(0);
          }}
        >
          Buscar
        </SearchButton>
        {search && (
          <ClearButton
            onClick={() => {
              setSearch("");
              setSearchInput("");
              setPage(0);
            }}
          >
            Limpar
          </ClearButton>
        )}
      </div>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Email</th>
              <th>Verificado</th>
              <th>Marca</th>
              <th>Whatsapp</th>
              <th>Data do fim do teste</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8}>Carregando...</td>
              </tr>
            ) : users.length === 0 ? (
              <tr>
                <td colSpan={8}>Nenhum usuário encontrado.</td>
              </tr>
            ) : (
              users.map((u) => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.isAccountVerified ? "Sim" : "Não"}</td>
                  <td>{u.brand?.name || "-"}</td>
                  <td>
                    {u.brand?.social.whatsapp &&
                    getWhatsappHref(u.brand.social.whatsapp) ? (
                      <a
                        href={getWhatsappHref(u.brand.social.whatsapp)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {u.brand.social.whatsapp}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    {u.trialEnd ? new Date(u.trialEnd).toLocaleString() : "-"}
                  </td>
                  <td>
                    <button
                      style={{
                        background: "#fbbf24",
                        color: "#22223b",
                        border: "none",
                        borderRadius: "0.5rem",
                        padding: "0.4rem 1rem",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "background 0.2s",
                      }}
                      onClick={() =>
                        setSelectedUserPayments({ id: u.id, name: u.name })
                      }
                    >
                      Pagamentos
                    </button>
                    {selectedUserPayments && (
                      <ModalOverlay>
                        <ModalContent>
                          <UserPaymentsDashboard
                            userId={selectedUserPayments.id}
                            userName={selectedUserPayments.name}
                            onClose={() => setSelectedUserPayments(null)}
                          />
                        </ModalContent>
                      </ModalOverlay>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </TableWrapper>
      {search.length === 0 && totalPages > 1 && (
        <Pagination>
          <PageButton
            onClick={() => setPage((p) => Math.max(0, p - 1))}
            disabled={page === 0}
          >
            Anterior
          </PageButton>
          <span>
            Página {page + 1} de {totalPages}
          </span>
          <PageButton
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
            disabled={page === totalPages - 1}
          >
            Próxima
          </PageButton>
        </Pagination>
      )}
    </Container>
  );
}
